/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Cloud_Voice_BadgeInputs */



/**
* | output |
* | --- |
* | "Cloud voice" |
*
* @param {Voice_Manager_Cloud_Voice_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_cloud_voice_badge = /** @type {((inputs?: Voice_Manager_Cloud_Voice_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Cloud_Voice_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voix cloud")
	if (locale === "de") return /** @type {LocalizedString} */ ("Cloud-Stimme")
	if (locale === "it") return /** @type {LocalizedString} */ ("Voce cloud")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Облачный голос")
	if (locale === "es") return /** @type {LocalizedString} */ ("Voz en la nube")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("云端语音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クラウド音声")
	if (locale === "hi") return /** @type {LocalizedString} */ ("क्लाउड आवाज़")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Voz na nuvem")
	return /** @type {LocalizedString} */ ("Cloud voice")
});